export default __webpack_public_path__ + "static/media/main_earth.33cfa764.png";